




































import {Component, Watch, Mixins, Vue} from 'vue-property-decorator'
import {$, IResource} from 'simpli-web-sdk'
import {snakeCase} from 'lodash'
import {AppConfig} from '@/config/app.config'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import FilterDelivery from '@/components/filters/FilterDelivery.vue'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import CargaCollection from '@/model/collection/CargaCollection'
import Carga from '@/model/resource/Carga'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'
import moment from 'moment'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryEnded.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, FilterDelivery},
})
export default class ReportsDeliveryEndedView extends Mixins(MixinFilter) {
  AppConfig = AppConfig

  filter = new DeliveryRequest()
  collection = new CargaCollection(this.filter)

  shown = ['slaStatus', 'sigla', 'insumo', 'tipoFinalizacao', 'tipoCriacao', 'manifesto']

  created() {
    this.filter.status = `${DeliveryStatus.FINISHED}`
    this.collection.orderBy = 'dataFinalizacao'
    this.collection.asc = false

    if (this.$route.query.start === undefined) {
      this.filter.startDate = moment().format()
    }
  }

  async downloadData(xlsx = false) {
    const title = this.$t('view.reports.deliveryEnded.title') as string

    if (!xlsx) {
      await $.await.run(() => Helper.downloadCsv(
        title,
        '/user/carga/csv',
        this.filter,
        true,
        4,
      ), 'download')
    } else {
      await $.await.run(() => Helper.downloadXlsx(
        title,
        '/user/carga/csv',
        this.filter,
        Carga,
        'Carga',
        true,
        4,
        ), 'download')
    }
  }
}
